<div class="credit-card" [class]="statusClass">
  <div class="card-header">
    <div class="header-info">
      <i class="pi pi-chart-pie"></i>
      <h3>Cifras de Control</h3>
    </div>
    <div class="completion-indicator">
      <span class="percentage">{{ completionPercentage }}%</span>
      <div class="progress-bar">
        <div class="progress-fill" [style.width.%]="completionPercentage"></div>
      </div>
    </div>
  </div>

  <div class="card-content">
    <div *ngIf="!hasData" class="no-data">
      <i class="pi pi-chart-pie"></i>
      <p>No hay cifras de control disponibles</p>
    </div>

    <div *ngIf="hasData" class="data-sections">
      <!-- Resumen Financiero -->
      <div class="section">
        <h4 class="section-title">Resumen Financiero</h4>
        <div class="financial-summary">
          <div class="summary-cards">
            <div class="summary-card total">
              <div class="card-icon">
                <i class="pi pi-wallet"></i>
              </div>
              <div class="card-content-summary">
                <div class="label">Total Adeudado</div>
                <div class="amount">{{ formatCurrency(totalDebt) }}</div>
              </div>
            </div>

            <div class="summary-card current" *ngIf="data?.totalCurrentBalances !== undefined">
              <div class="card-icon">
                <i class="pi pi-check-circle"></i>
              </div>
              <div class="card-content-summary">
                <div class="label">Saldos Actuales</div>
                <div class="amount">{{ formatCurrency(data?.totalCurrentBalances) }}</div>
              </div>
            </div>

            <div class="summary-card overdue" 
                 [class]="'status-' + debtHealthStatus"
                 *ngIf="data?.totalPastDueBalances !== undefined">
              <div class="card-icon">
                <i class="pi pi-exclamation-triangle"></i>
              </div>
              <div class="card-content-summary">
                <div class="label">Saldos Vencidos</div>
                <div class="amount">{{ formatCurrency(data?.totalPastDueBalances) }}</div>
              </div>
            </div>
          </div>

          <!-- Indicador de Salud Crediticia -->
          <div class="debt-health" [class]="'health-' + debtHealthStatus">
            <div class="health-header">
              <i class="pi" [class]="debtHealthStatus === 'good' ? 'pi-check' : 
                                   debtHealthStatus === 'warning' ? 'pi-exclamation-triangle' : 'pi-times'"></i>
              <span class="health-label">Estado Crediticio: 
                <strong>{{ debtHealthStatus === 'good' ? 'Excelente' : 
                           debtHealthStatus === 'warning' ? 'Precaución' : 'Riesgo' }}</strong>
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Elementos Reportados -->
      <div class="section">
        <h4 class="section-title">Elementos Reportados</h4>
        <div class="reporting-grid">
          <div class="reporting-item" [class.empty]="data?.totalNameElementsReported === null || data?.totalNameElementsReported === undefined">
            <div class="reporting-header">
              <i class="pi pi-user"></i>
              <span class="label">Nombres</span>
            </div>
            <div [class]="data?.totalNameElementsReported !== null && data?.totalNameElementsReported !== undefined ? 'count' : 'count placeholder'">
              {{ data?.totalNameElementsReported !== null && data?.totalNameElementsReported !== undefined ? data?.totalNameElementsReported : 'No especificado' }}
            </div>
          </div>

          <div class="reporting-item" [class.empty]="data?.totalAddressElementsReported === null || data?.totalAddressElementsReported === undefined">
            <div class="reporting-header">
              <i class="pi pi-map-marker"></i>
              <span class="label">Direcciones</span>
            </div>
            <div [class]="data?.totalAddressElementsReported !== null && data?.totalAddressElementsReported !== undefined ? 'count' : 'count placeholder'">
              {{ data?.totalAddressElementsReported !== null && data?.totalAddressElementsReported !== undefined ? data?.totalAddressElementsReported : 'No especificado' }}
            </div>
          </div>

          <div class="reporting-item" [class.empty]="data?.totalEmploymentElementsReported === null || data?.totalEmploymentElementsReported === undefined">
            <div class="reporting-header">
              <i class="pi pi-briefcase"></i>
              <span class="label">Empleos</span>
            </div>
            <div [class]="data?.totalEmploymentElementsReported !== null && data?.totalEmploymentElementsReported !== undefined ? 'count' : 'count placeholder'">
              {{ data?.totalEmploymentElementsReported !== null && data?.totalEmploymentElementsReported !== undefined ? data?.totalEmploymentElementsReported : 'No especificado' }}
            </div>
          </div>

          <div class="reporting-item" [class.empty]="data?.totalAccountElementsReported === null || data?.totalAccountElementsReported === undefined">
            <div class="reporting-header">
              <i class="pi pi-credit-card"></i>
              <span class="label">Cuentas</span>
            </div>
            <div [class]="data?.totalAccountElementsReported !== null && data?.totalAccountElementsReported !== undefined ? 'count' : 'count placeholder'">
              {{ data?.totalAccountElementsReported !== null && data?.totalAccountElementsReported !== undefined ? data?.totalAccountElementsReported : 'No especificado' }}
            </div>
          </div>
        </div>

        <!-- Indicador de Completitud -->
        <div class="completeness-indicator" [class]="'completeness-' + getCompletenessStatus()">
          <div class="completeness-header">
            <span class="completeness-label">Completitud de Información:</span>
            <span class="completeness-percentage">{{ getReportingCompleteness() }}%</span>
          </div>
          <div class="completeness-bar">
            <div class="completeness-fill" [style.width.%]="getReportingCompleteness()"></div>
          </div>
          <div class="completeness-status">
            {{ getCompletenessStatus() === 'excellent' ? 'Excelente' :
               getCompletenessStatus() === 'good' ? 'Buena' :
               getCompletenessStatus() === 'fair' ? 'Regular' : 'Deficiente' }}
          </div>
        </div>
      </div>

      <!-- Información Adicional -->
      <div class="section" *ngIf="data?.grantorName || data?.returnAddress">
        <h4 class="section-title">Información Adicional</h4>
        <div class="data-grid">
          <div class="data-item" [class.empty]="!data?.grantorName">
            <label>Otorgante:</label>
            <span [class]="data?.grantorName ? 'value' : 'placeholder'">
              {{ data?.grantorName || 'No especificado' }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.returnAddress">
            <label>Dirección de Devolución:</label>
            <span [class]="data?.returnAddress ? 'value' : 'placeholder'">
              {{ data?.returnAddress || 'No especificado' }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
